const QUOTE_ERRORS = {
  ROUTE: 'route',
  LH_EXPRESS_VEHICLE_TYPE: 'lh_express_vehicle_type',
};

const QUOTE_ERROR_CODE_RESPONSES = {
  LH_EXPRESS_VEHICLE_TYPE:
    'Unsupported route LH_EXPRESS vehicle type not allowed',
};

export default {
  QUOTE_ERRORS,
  QUOTE_ERROR_CODE_RESPONSES,
};
